// extracted by mini-css-extract-plugin
export default {"cartContainer":"CartStructure_cartContainer__xNJYj","cartMainContainer":"CartStructure_cartMainContainer__XkxEi"};